import { ALERT_OPEN, ALERT_CLOSE } from "../actions/alert"

const alertInitialState = {
  open: false,
  title: "Alert",
  body: "Something happened",
  declineButtonText: "Never Mind",
  acceptButtonText: "Yep",
}

export default (state = alertInitialState, action) => {
  switch (action.type) {
    case ALERT_OPEN:
    case ALERT_CLOSE:
      const { type, ...rest } = action
      return {
        ...state,
        ...rest,
      }
    default:
      return state
  }
}
